/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Shared_UiInputs */

const en_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared UI`)
};

const ar_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة مشتركة`)
};

const bn_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শেয়ার্ড UI`)
};

const de_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeinsame Benutzeroberfläche`)
};

const es_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IU compartida`)
};

const fr_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interface utilisateur partagée`)
};

const pt_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IU compartilhada`)
};

const zh_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共享 UI`)
};

const tr_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paylaşılan Kullanıcı Arayüzü`)
};

const ru_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общий пользовательский интерфейс`)
};

const pl_svchip_shared_ui = /** @type {(inputs: Svchip_Shared_UiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udostępniony interfejs użytkownika`)
};

/**
* | output |
* | --- |
* | "Shared UI" |
*
* @param {Svchip_Shared_UiInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_shared_ui = /** @type {((inputs?: Svchip_Shared_UiInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Shared_UiInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_shared_ui(inputs)
	if (locale === "bn") return bn_svchip_shared_ui(inputs)
	if (locale === "de") return de_svchip_shared_ui(inputs)
	if (locale === "es") return es_svchip_shared_ui(inputs)
	if (locale === "fr") return fr_svchip_shared_ui(inputs)
	if (locale === "pt") return pt_svchip_shared_ui(inputs)
	if (locale === "zh") return zh_svchip_shared_ui(inputs)
	if (locale === "tr") return tr_svchip_shared_ui(inputs)
	if (locale === "ru") return ru_svchip_shared_ui(inputs)
	if (locale === "pl") return pl_svchip_shared_ui(inputs)
	return en_svchip_shared_ui(inputs)
});